import { CommentService } from './services/comment.service';
import { RelationCommentService } from './services/relation-comment.service';

export { CommentService } from './services/comment.service';
export { RelationCommentService } from './services/relation-comment.service';

export const Services = [
    CommentService,
    RelationCommentService
];



// WEBPACK FOOTER //
// ./libs/chassis-comments/src/app/services.ts